import { Injectable } from '@angular/core';
import { HttpService } from '..';
import { Observable, forkJoin } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {

  constructor(private readonly _httpClient: HttpService) { }

  addOldQustion(data: any[]): Observable<any> {
    const updates = data.map(question => 
      this._httpClient.put(`rest/v1/questions?id=eq.${question.id}`, question, false)
    );
    return forkJoin(updates);
  }

  addNewQustion(data: any): Observable<any> {
    return this._httpClient.post('rest/v1/questions', data, false);
  }

  deleteQuestions(questionIds: number[]): Observable<any> {
    // For Supabase, we need to update records individually or use a filter
    // We'll use PATCH with an 'in' filter to update multiple records at once
    const idsString = questionIds.join(',');
    const data = { status: false };
    
    // Try the batch update approach first
    return this._httpClient.patch(`rest/v1/questions?id=in.(${idsString})`, data, false);
  }

  deleteQuestionIndividually(questionId: number): Observable<any> {
    // Fallback: delete one question at a time
    const data = { status: false };
    return this._httpClient.patch(`rest/v1/questions?id=eq.${questionId}`, data, false);
  }

  loadQuestions(templateId?: string): Observable<any> {
    const templateFilter = templateId ? `&template_id=eq.${templateId}` : '';
    return this._httpClient.get(
      `rest/v1/questions?select=id,question_text,status,order,template_id&order=order.asc.nullslast${templateFilter}`
    );
  }

  updateQuestionOrder(questionId: number, order: number): Observable<any> {
    const data = { order: order };
    return this._httpClient.put(`rest/v1/questions?id=eq.${questionId}`, data, false);
  }

  updateQuestionsOrder(questions: { id: number, order: number }[]): Observable<any> {
    // Update multiple questions' order using individual requests
    const updates = questions.map(q => this.updateQuestionOrder(q.id, q.order));
    return forkJoin(updates);
  }
}
